import glamorous from 'glamorous';
import { css } from 'glamor';

const spin = css.keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

const background = 'transparent';

export const LoadingImage = glamorous.svg(({ pixelWidth, foreground = 'navy' }) => ({
  borderColor: `${foreground} ${foreground} ${foreground} ${background}`,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderRadius: '50%',
  width: `${pixelWidth}px`,
  height: `${pixelWidth}px`,
  transform: 'translateZ(0)',
  animation: `${spin} 1.1s linear infinite`,
  fontSize: '2px',
  textIndent: '-9999em',
}));
LoadingImage.displayName = 'LoadingImage';

const horizontalAlignMap = {
  right: 'flex-end',
  left: 'flex-start',
  center: 'center',
};
export const LoadingWrapper = glamorous.div(({ horizontalAlign }) => ({
  // height: '100vh',
  // width: '100%',
  display: 'flex',
  justifyContent: horizontalAlignMap[horizontalAlign],
  alignItems: 'center',
  backgroundColor: background,
}));
LoadingWrapper.displayName = 'LoadingWrapper';



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.style.js